import clsx from "clsx";
import { ComponentPropsWithRef, forwardRef } from "react";
import { ValidationError } from "../../../util/customHooks/validation/useValidation";
import { useFormControlContext } from "../../FormControlContext/FormControlContext";
import "./input.scss";

interface IInputOwnProps {
    fullWidth?: boolean;
    error?: ValidationError;
}
interface IInputProps extends IInputOwnProps, Omit<ComponentPropsWithRef<"input">, keyof IInputOwnProps> { }

export const Input = forwardRef<HTMLInputElement, IInputProps>((props, forwardedRef) => {
    const { id: controlledId, fullWidth = false, disabled: controlledDisabled, error, ...restProps } = props;

    const { id: uncontrolledId, disabled: uncontrolledDisabled, state } = useFormControlContext();

    return (
        <input
            {...restProps}
            ref={forwardedRef}
            id={controlledId || uncontrolledId}
            disabled={controlledDisabled || uncontrolledDisabled}
            className={clsx(
                "farmact-input",
                {
                    "farmact-input--full-width": fullWidth,
                    //
                    "farmact-input--state-normal": state === "normal",
                    "farmact-input--state-warning": state === "warning",
                    "farmact-input--state-error": state === "error" || error,
                },
                props.className
            )}
        />
    );
});
